import {Box} from "@mui/material";

export default function CardBody(props) {
  return (
    <Box p={{xs: 2, md: 5}}>
      {props.children}
    </Box>
  )
}